/**
 * THE PORTAL'S BUTTON ICONS — thin line icons from the app's own library
 * (lucide-react), drawn in the page. No image file, no outside request.
 *
 * The capability belongs to every clinic; it only appears when that clinic
 * turns "Show icons on buttons" on in Design. These are the only buttons that
 * ever carry one — a title, Accept, Continue, Back or Sign out never does.
 */
import { CalendarDays, CreditCard, Gem, Gift, Mail, Phone, Ticket } from 'lucide-react';

export const BUTTON_ICONS = {
    bank_give: Gift,
    bank_redeem: Ticket,
    gifts_bank: CreditCard,
    gifts_create: Ticket,
    vip_create_card_btn: Ticket,
    contact_email: Mail,
    contact_call: Phone,
    home_contact: Phone,
    home_bookings: CalendarDays,
    home_vip: Gem,
};
